import { render } from "./disposedFixedAssetProducts.vue?vue&type=template&id=60e79fb6&scoped=true"
import script from "./disposedFixedAssetProducts.vue?vue&type=script&lang=js"
export * from "./disposedFixedAssetProducts.vue?vue&type=script&lang=js"

import "./disposedFixedAssetProducts.vue?vue&type=style&index=0&id=60e79fb6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abbas\\Desktop\\kswc\\kswc_dashboard-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60e79fb6"]])

export default __exports__